export interface ComicItem {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  coverSeq: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  latestChapter: number;
  description: string;
  rating: number;
  views: string;
  tags: string[];
  updatedAt: string;
}

export const featuredComics: ComicItem[] = [
  {
    id: '1',
    slug: 'duzhe-fuchou-ji',
    title: '独子复仇记',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20cover%20art%20style%2C%20dark%20fantasy%20revenge%20theme%2C%20male%20protagonist%20with%20sword%2C%20dramatic%20lighting%2C%20manga%20style%20illustration%2C%20rich%20dark%20red%20and%20black%20color%20palette%2C%20intense%20atmosphere%2C%20detailed%20lineart%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    coverSeq: 'comic-cover-01',
    category: '动作热血',
    categorySlug: 'action',
    status: '连载中',
    latestChapter: 87,
    description: '家族被灭门的少年，独自踏上复仇之路。在血与火的洗礼中，他将揭开惊天阴谋，成为最强剑士。',
    rating: 9.6,
    views: '2850万',
    tags: ['复仇', '剑术', '成长', '热血'],
    updatedAt: '2026-07-04',
  },
  {
    id: '2',
    slug: 'miyue-zhiwen',
    title: '蜜月之吻',
    author: '李秀妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20couple%20embracing%2C%20soft%20pink%20and%20pastel%20tones%2C%20wedding%20theme%2C%20elegant%20illustration%20style%2C%20romantic%20atmosphere%2C%20detailed%20character%20design%2C%20clean%20lineart%2C%20dreamy%20composition&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    coverSeq: 'comic-cover-02',
    category: '浪漫恋爱',
    categorySlug: 'romance',
    status: '连载中',
    latestChapter: 56,
    description: '契约婚姻从一纸协议开始，却在不经意间萌生了真心。霸道总裁与平凡女孩的甜蜜拉扯。',
    rating: 9.3,
    views: '1820万',
    tags: ['契约婚姻', '总裁', '甜宠', '都市'],
    updatedAt: '2026-07-03',
  },
  {
    id: '3',
    slug: 'yijie-yongzhe',
    title: '异界勇者传',
    author: '朴正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20hero%20with%20magical%20powers%20in%20another%20world%2C%20epic%20landscape%20background%2C%20glowing%20magic%20effects%2C%20adventure%20theme%2C%20rich%20golden%20and%20emerald%20colors%2C%20detailed%20armor%20design%2C%20cinematic%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    coverSeq: 'comic-cover-03',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    status: '连载中',
    latestChapter: 132,
    description: '被召唤到异世界的普通高中生，意外获得最强职业。与伙伴们一起探索未知大陆的冒险故事。',
    rating: 9.5,
    views: '4210万',
    tags: ['异世界', '冒险', '魔法', '团队'],
    updatedAt: '2026-07-04',
  },
  {
    id: '4',
    slug: 'heian-zhuizong',
    title: '黑暗追踪',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%2C%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20rainy%20city%20street%2C%20mysterious%20silhouette%2C%20crime%20investigation%20theme%2C%20blue%20gray%20and%20black%20tones%2C%20suspenseful%20mood%2C%20detailed%20background%20art&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    coverSeq: 'comic-cover-04',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '连载中',
    latestChapter: 45,
    description: '连环失踪案背后隐藏着怎样的秘密？前刑警孤身追查，一步步陷入更深的黑暗漩涡。',
    rating: 9.1,
    views: '980万',
    tags: ['悬疑', '推理', '犯罪', '都市'],
    updatedAt: '2026-07-02',
  },
  {
    id: '5',
    slug: 'gaoxiao-riji',
    title: '爆笑日常',
    author: '韩智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20school%20life%20scene%2C%20exaggerated%20expressions%2C%20colorful%20and%20bright%20illustration%2C%20slice%20of%20life%20theme%2C%20chibi%20style%20characters%2C%20warm%20yellow%20and%20orange%20tones%2C%20playful%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    coverSeq: 'comic-cover-05',
    category: '搞笑日常',
    categorySlug: 'comedy',
    status: '已完结',
    latestChapter: 120,
    description: '一群高中生的爆笑校园生活。考试、暗恋、社团活动，每一天都充满欢乐与感动。',
    rating: 9.4,
    views: '3560万',
    tags: ['校园', '搞笑', '日常', '青春'],
    updatedAt: '2026-06-28',
  },
  {
    id: '6',
    slug: 'tianshi-zhi lei',
    title: '天使之泪',
    author: '姜美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20emotional%20scene%20with%20tears%2C%20melodramatic%20atmosphere%2C%20beautiful%20female%20character%2C%20sad%20and%20touching%20mood%2C%20soft%20warm%20lighting%2C%20delicate%20illustration%20style%2C%20white%20and%20pale%20gold%20tones%2C%20poetic%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    coverSeq: 'comic-cover-06',
    category: '剧情人生',
    categorySlug: 'drama',
    status: '连载中',
    latestChapter: 68,
    description: '失去声音的天才钢琴少女，用音乐治愈自己和身边人的温暖故事。准备好纸巾再看。',
    rating: 9.7,
    views: '1980万',
    tags: ['音乐', '治愈', '成长', '感人'],
    updatedAt: '2026-07-04',
  },
  {
    id: '7',
    slug: 'mowang-jueqi',
    title: '魔王崛起',
    author: '宋志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20demon%20lord%20rising%20with%20dark%20aura%2C%20gothic%20castle%20background%2C%20epic%20battle%20scene%2C%20dark%20magic%20effects%2C%20purple%20and%20black%20color%20scheme%2C%20powerful%20male%20character%2C%20menacing%20atmosphere%2C%20detailed%20armor&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    coverSeq: 'comic-cover-07',
    category: '动作热血',
    categorySlug: 'action',
    status: '连载中',
    latestChapter: 95,
    description: '被封印千年的魔王在现代苏醒，却发现世界已完全不同。他决定重新征服这个属于人类的世界。',
    rating: 9.2,
    views: '3120万',
    tags: ['魔王', '现代', '战斗', '逆袭'],
    updatedAt: '2026-07-03',
  },
  {
    id: '8',
    slug: 'huayang-nianhua',
    title: '花样年华',
    author: '尹素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20young%20couple%20under%20cherry%20blossoms%2C%20spring%20theme%2C%20youth%20and%20first%20love%2C%20soft%20pink%20and%20white%20color%20palette%2C%20dreamy%20and%20nostalgic%20mood%2C%20beautiful%20character%20art%2C%20gentle%20illustration%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    coverSeq: 'comic-cover-08',
    category: '浪漫恋爱',
    categorySlug: 'romance',
    status: '已完结',
    latestChapter: 84,
    description: '大学校园里的青涩初恋，从相遇到错过再到重逢。最美的年华里，感谢曾经遇见你。',
    rating: 9.5,
    views: '2650万',
    tags: ['校园', '初恋', '重逢', '治愈'],
    updatedAt: '2026-06-30',
  },
];

export const latestUpdates: ComicItem[] = [
  {
    id: '9',
    slug: 'jianling-qiyuan',
    title: '剑灵契约',
    author: '郑太贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20swordsman%20with%20spirit%20blade%2C%20ancient%20eastern%20setting%2C%20martial%20arts%20theme%2C%20flowing%20energy%20effects%2C%20dynamic%20pose%2C%20red%20and%20gold%20accent%20colors%2C%20traditional%20clothing%2C%20epic%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    coverSeq: 'comic-cover-09',
    category: '动作热血',
    categorySlug: 'action',
    status: '连载中',
    latestChapter: 23,
    description: '少年意外与上古剑灵签订契约，从此踏上修炼之路，揭开剑灵背后的千年秘密。',
    rating: 8.9,
    views: '320万',
    tags: ['剑灵', '修炼', '上古', '契约'],
    updatedAt: '2026-07-04',
  },
  {
    id: '10',
    slug: 'xingkong-wangzuo',
    title: '星空王座',
    author: '赵贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20fantasy%20manhwa%20cover%2C%20space%20throne%20with%20stars%2C%20galactic%20empire%20theme%2C%20futuristic%20armor%2C%20cosmic%20background%2C%20deep%20navy%20and%20silver%20color%20scheme%2C%20majestic%20atmosphere%2C%20detailed%20mecha%20design&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    coverSeq: 'comic-cover-10',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    status: '连载中',
    latestChapter: 41,
    description: '星际帝国崩塌之际，流亡王子率领残军重返星空，夺回属于他的王座与荣耀。',
    rating: 9.0,
    views: '850万',
    tags: ['星际', '帝国', '王子', '机甲'],
    updatedAt: '2026-07-04',
  },
  {
    id: '11',
    slug: 'shenmi-shangdian',
    title: '神秘商店',
    author: '金瑞元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20manhwa%20cover%2C%20mysterious%20antique%20shop%20interior%2C%20magical%20artifacts%2C%20dark%20and%20warm%20lighting%2C%20curious%20atmosphere%2C%20hidden%20secrets%20theme%2C%20rich%20brown%20and%20gold%20tones%2C%20detailed%20item%20design&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    coverSeq: 'comic-cover-11',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '连载中',
    latestChapter: 15,
    description: '巷子深处的古董店只在午夜营业，每一件商品都能实现一个愿望——但代价是什么？',
    rating: 9.3,
    views: '560万',
    tags: ['神秘', '愿望', '代价', '都市传说'],
    updatedAt: '2026-07-03',
  },
  {
    id: '12',
    slug: 'chongwu-julebu',
    title: '宠物俱乐部',
    author: '朴恩智',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20slice%20of%20life%20manhwa%20cover%2C%20cute%20animals%20and%20their%20owners%2C%20pet%20cafe%20setting%2C%20heartwarming%20scenes%2C%20bright%20and%20cheerful%20colors%2C%20soft%20pastel%20tone%2C%20funny%20animal%20expressions%2C%20cozy%20atmosphere&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    coverSeq: 'comic-cover-12',
    category: '搞笑日常',
    categorySlug: 'comedy',
    status: '连载中',
    latestChapter: 37,
    description: '宠物咖啡馆的日常，每一个毛孩子都有自己的小脾气和小心思。萌宠与人类的治愈故事。',
    rating: 9.1,
    views: '1280万',
    tags: ['宠物', '治愈', '日常', '咖啡馆'],
    updatedAt: '2026-07-04',
  },
];

export const categories = [
  { name: '动作热血', slug: 'action', icon: 'ri-sword-line', count: 256, color: 'text-primary-500 bg-primary-500/10', image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20theme%20collage%2C%20intense%20battle%20scenes%2C%20martial%20arts%2C%20dark%20atmospheric%20comics%20art%2C%20warm%20red%20and%20black%20tones%2C%20dramatic%20composition%2C%20comic%20panel%20style%2C%20cinematic%20mood&width=800&height=500&seq=category-action&orientation=landscape' },
  { name: '浪漫恋爱', slug: 'romance', icon: 'ri-heart-line', count: 198, color: 'text-accent-500 bg-accent-500/10', image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20theme%20collage%2C%20beautiful%20couples%20embracing%2C%20soft%20pink%20and%20pastel%20tones%2C%20romantic%20atmosphere%2C%20elegant%20illustration%20style%2C%20dreamy%20composition%2C%20comic%20panel%20aesthetic&width=800&height=500&seq=category-romance&orientation=landscape' },
  { name: '奇幻冒险', slug: 'fantasy', icon: 'ri-rocket-line', count: 187, color: 'text-accent-500 bg-accent-500/10', image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20theme%20collage%2C%20magical%20worlds%2C%20heroes%20with%20powers%2C%20epic%20landscapes%2C%20floating%20islands%2C%20golden%20and%20emerald%20tones%2C%20cinematic%20illustration%2C%20comic%20panel%20style&width=800&height=500&seq=category-fantasy&orientation=landscape' },
  { name: '悬疑惊悚', slug: 'thriller', icon: 'ri-search-eye-line', count: 94, color: 'text-secondary-400 bg-secondary-400/10', image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20mystery%20manhwa%20theme%20collage%2C%20dark%20alleyways%2C%20detective%20noir%20atmosphere%2C%20crime%20investigation%2C%20blue%20gray%20and%20black%20tones%2C%20suspenseful%20mood%2C%20comic%20panel%20aesthetic%2C%20cinematic%20style&width=800&height=500&seq=category-thriller&orientation=landscape' },
  { name: '搞笑日常', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 145, color: 'text-accent-500 bg-accent-500/10', image: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20theme%20collage%2C%20funny%20school%20life%20scenes%2C%20exaggerated%20expressions%2C%20colorful%20bright%20illustration%2C%20slice%20of%20life%2C%20chibi%20style%2C%20warm%20yellow%20tones%2C%20playful%20composition&width=800&height=500&seq=category-comedy&orientation=landscape' },
  { name: '剧情人生', slug: 'drama', icon: 'ri-movie-2-line', count: 112, color: 'text-primary-500 bg-primary-500/10', image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20theme%20collage%2C%20emotional%20storytelling%2C%20touching%20scenes%2C%20musical%20and%20artistic%20themes%2C%20soft%20warm%20lighting%2C%20delicate%20illustration%20style%2C%20white%20and%20gold%20tones%2C%20poetic%20composition&width=800&height=500&seq=category-drama&orientation=landscape' },
];

export const testimonials = [
  {
    id: 't1',
    name: '漫画迷小王',
    role: '资深读者 · 3年书龄',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20casual%20style%2C%20warm%20smile%2C%20clean%20background%2C%20natural%20lighting%2C%20simple%20composition&width=80&height=80&seq=avatar-t1&orientation=squarish',
    avatarSeq: 'avatar-t1',
    comment: '韩漫画网的下拉式阅读真的太爽了！不用翻页，一气呵成看完整话，画质清晰加载快，比APP还好用。',
    rating: 5,
  },
  {
    id: 't2',
    name: '追更少女',
    role: 'VIP会员 · 2年书龄',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20trendy%20style%2C%20bright%20smile%2C%20minimal%20background%2C%20soft%20natural%20light%2C%20clean%20composition&width=80&height=80&seq=avatar-t2&orientation=squarish',
    avatarSeq: 'avatar-t2',
    comment: '资源超全，更新超快。每天通勤路上必看，韩漫画网已经成了我生活中不可缺少的一部分！',
    rating: 5,
  },
  {
    id: 't3',
    name: '阿宅阿强',
    role: '骨灰级漫迷 · 8年书龄',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20gentle%20expression%2C%20plain%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-t3&orientation=squarish',
    avatarSeq: 'avatar-t3',
    comment: '作为看了八年漫画的老粉，韩漫画网的收录速度和翻译质量都是顶尖水准。无广告干扰的阅读体验，这个必须点赞！',
    rating: 5,
  },
  {
    id: 't4',
    name: '夜猫子读书人',
    role: '活跃读者 · 1年书龄',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20woman%20portrait%2C%20night%20owl%20vibe%2C%20cozy%20expression%2C%20dark%20hair%2C%20simple%20background%2C%20warm%20ambient%20light%2C%20casual%20headshot&width=80&height=80&seq=avatar-t4&orientation=squarish',
    avatarSeq: 'avatar-t4',
    comment: '深夜睡不着就打开韩漫画网，暗色模式对眼睛友好，下拉式阅读让我躺床上也能轻松看。五星推荐！',
    rating: 5,
  },
  {
    id: 't5',
    name: '上班摸鱼侠',
    role: '铁杆粉丝 · 5年书龄',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%2C%20office%20worker%20style%2C%20friendly%20smile%2C%20clean%20background%2C%20natural%20light%2C%20professional%20casual%20headshot&width=80&height=80&seq=avatar-t5&orientation=squarish',
    avatarSeq: 'avatar-t5',
    comment: '分类做得特别好，找漫画一目了然。推荐算法也很准，总能给我推对胃口的新作品。书荒救星！',
    rating: 5,
  },
];

export const rankingComics = [
  { rank: 1, title: '独子复仇记', views: '2850万', slug: 'duzhe-fuchou-ji', coverSeq: 'comic-cover-01', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20dark%20fantasy%20revenge%2C%20swordsman%2C%20dramatic%20red%20and%20black%20tones%2C%20intense%20expression%2C%20detailed%20lineart&width=200&height=280&seq=rank-01&orientation=portrait' },
  { rank: 2, title: '异界勇者传', views: '4210万', slug: 'yijie-yongzhe', coverSeq: 'comic-cover-03', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20hero%20with%20magic%2C%20golden%20and%20green%20tones%2C%20epic%20adventure%2C%20dynamic%20pose&width=200&height=280&seq=rank-02&orientation=portrait' },
  { rank: 3, title: '爆笑日常', views: '3560万', slug: 'gaoxiao-riji', coverSeq: 'comic-cover-05', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20school%20life%2C%20colorful%20bright%20tones%2C%20chibi%20style%2C%20playful&width=200&height=280&seq=rank-03&orientation=portrait' },
  { rank: 4, title: '魔王崛起', views: '3120万', slug: 'mowang-jueqi', coverSeq: 'comic-cover-07', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20demon%20lord%2C%20dark%20aura%2C%20gothic%20castle%2C%20epic%2C%20detailed%20armor&width=200&height=280&seq=rank-04&orientation=portrait' },
  { rank: 5, title: '花样年华', views: '2650万', slug: 'huayang-nianhua', coverSeq: 'comic-cover-08', coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20cherry%20blossoms%2C%20young%20couple%2C%20spring%2C%20soft%20pink%20tones%2C%20dreamy&width=200&height=280&seq=rank-05&orientation=portrait' },
];

export const heroSlides = [
  {
    id: 'hero-1',
    title: '独子复仇记',
    subtitle: '血与火的复仇史诗',
    bgImage: 'https://readdy.ai/api/search-image?query=Dark%20epic%20Korean%20manhwa%20style%20background%2C%20dramatic%20swordsman%20silhouette%20against%20burning%20castle%2C%20warm%20red%20and%20black%20atmosphere%2C%20cinematic%20lighting%2C%20emotional%20and%20powerful%20composition%2C%20no%20text%2C%20illustration%20style&width=1600&height=900&seq=hero-bg-2026-01&orientation=landscape',
    slug: 'duzhe-fuchou-ji',
  },
  {
    id: 'hero-2',
    title: '异界勇者传',
    subtitle: '穿越异世界的奇幻冒险',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20style%20background%2C%20magical%20portal%20opening%20to%20another%20world%2C%20floating%20islands%20and%20castles%2C%20warm%20golden%20and%20emerald%20light%2C%20adventurous%20atmosphere%2C%20cinematic%20wide%20shot%2C%20illustration%20style&width=1600&height=900&seq=hero-bg-2026-02&orientation=landscape',
    slug: 'yijie-yongzhe',
  },
  {
    id: 'hero-3',
    title: '天使之泪',
    subtitle: '用音乐治愈心灵的温暖故事',
    bgImage: 'https://readdy.ai/api/search-image?query=Warm%20and%20emotional%20Korean%20manhwa%20style%20background%2C%20piano%20in%20soft%20spotlight%2C%20floating%20musical%20notes%2C%20gentle%20golden%20and%20white%20atmosphere%2C%20healing%20and%20touching%20mood%2C%20dreamy%20cinematic%20composition%2C%20illustration%20style&width=1600&height=900&seq=hero-bg-2026-03&orientation=landscape',
    slug: 'tianshi-zhi-lei',
  },
];